import { Basics } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class Project extends Default {
  _toggleBtn;
  _toggle = () => this.toggle();

  constructor() {
    super();

    this._toggleBtn = GetBy.selector('[data-txt]', this.container)[0];
    this._toggleBtn.addEventListener(Basics.clickEvent, this._toggle);
  }

  toggle() {
    if (this.container.classList.contains('--text')) {
      this.container.classList.remove('--text');
      this._toggleBtn.classList.remove('--active')
    } else {
      this.container.classList.add('--text');
      this._toggleBtn.classList.add('--active')
    }
  }

  beforeHide() {
    super.beforeHide();
    this._toggleBtn.removeEventListener(Basics.clickEvent, this._toggle);
  }
}

ControllerPage._addPage('project', Project);
